import Navbar from "../../component/Navbar";
import DropdownMenu from "../../component/DropdownMenu";
import Footer from "../../component/Footer";
import { useState } from "react";
import PageTransition from "../../component/PageTransition";

export default function Page() {
  const [showContent, setShowContent] = useState(false);

  // Core Values Data
  const coreValues = [
    {
      letter: "V",
      title: "Versatility",
      description: "ความสามารถในการปรับตัว มีความยืดหยุ่นในการทำงาน และหน้าที่ต่างๆ ได้อย่างหลากหลาย และมีประสิทธิภาพ",
      color: "text-[#5eafd2]",
      bgColor: "bg-[#5eafd2]/10",
      borderColor: "border-[#5eafd2]"
    },
    {
      letter: "M",
      title: "Motivation",
      description: "ส่งเสริมและผลักดัน ให้กำลังใจในการทำงานระหว่างกันและกันในผู้ร่วมงาน เพื่อให้มีความสัมพันธ์และประสิทธิภาพที่ดียิ่งขึ้น",
      color: "text-[#9E76B3]",
      bgColor: "bg-[#9E76B3]/10",
      borderColor: "border-[#9E76B3]"
    },
    {
      letter: "C",
      title: "Community Engagement",
      description: "มุ่งเน้นท้องถิ่น และมีความรับผิดชอบต่อสังคม",
      color: "text-[#0F4D81]",
      bgColor: "bg-[#0F4D81]/10",
      borderColor: "border-[#0F4D81]"
    },
    {
      letter: "M",
      title: "Morality",
      description: "ยึดหลักธรรมมาภิบาล เชิดชูคุณธรรม พัฒนาจิตอาสา/จิตสาธารณะ/จิตบริการ",
      color: "text-[#5eafd2]",
      bgColor: "bg-[#5eafd2]/10",
      borderColor: "border-[#5eafd2]"
    },
    {
      letter: "U",
      title: "Unity",
      description: "ทำงานเป็นทีม บุคลากรสามัคคี และเป็นองค์กรแห่งความสุข",
      color: "text-[#9E76B3]",
      bgColor: "bg-[#9E76B3]/10",
      borderColor: "border-[#9E76B3]"
    }
  ];

  // Vision Data
  const visionData = {
    title: "วิสัยทัศน์ / Vision",
    subtitle: "ศูนย์กลางองค์ความรู้และบริการด้านสัตวแพทย์ระดับสากล",
    english: "Center of Veterinary Knowledge and Services with Global Standards"
  };

  // Mission Data
  const missions = [
    {
      th: "ให้บริการทางการสัตวแพทย์ด้วยมาตรฐานสากลและเทคโนโลยีที่ทันสมัย",
      en: "To provide veterinary services with international standards and advanced technology"
    },
    {
      th: "พัฒนาการเรียนรู้และฝึกปฏิบัติทางคลินิกอย่างมีคุณภาพ",
      en: "To enhance learning and clinical training with high quality standards"
    },
    {
      th: "สนับสนุนงานวิจัยและนวัตกรรมเพื่อยกระดับการรักษา",
      en: "To support research and innovation for advanced veterinary care and treatment"
    },
    {
      th: "ถ่ายทอดองค์ความรู้และสร้างเครือข่ายวิชาชีพทั้งในและต่างประเทศ",
      en: "To disseminate knowledge and strengthen professional networks both nationally and internationally"
    },
    {
      th: "บริหารองค์การตามหลักคุณภาพและธรรมาภิบาล",
      en: "To manage the organization under the principles of quality management and good governance"
    }
  ];

  return (
    <>
      <PageTransition showContent={showContent} setShowContent={setShowContent}>
        พันธกิจและวิสัยทัศน์
      </PageTransition>
      {showContent && (
        <div className="relative bg-gradient-to-b from-white via-[#f8f9fc] to-white">
          <Navbar />
          <div className="flex flex-col gap-y-5">
            <DropdownMenu />

            {/* Hero Section */}
            <div className="relative overflow-hidden bg-gradient-to-r from-[#0F4D81] to-[#1a6bb0] py-12 md:py-20">
              <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -mr-20 -mt-20"></div>
              <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/5 rounded-full -ml-16 -mb-16"></div>
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-white/5 rounded-full"></div>

              <div className="container mx-auto px-4 md:px-6 relative z-10 text-center">
                <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 tracking-wide">
                  วิสัยทัศน์และพันธกิจ
                </h1>

                <div className="flex justify-center gap-2 mt-4">
                  <span className="inline-block w-12 h-1 bg-[#9E76B3] rounded-full"></span>
                  <span className="inline-block w-12 h-1 bg-[#5eafd2] rounded-full"></span>
                  <span className="inline-block w-12 h-1 bg-white/50 rounded-full"></span>
                </div>
              </div>
            </div>

            <div className="container mx-auto w-full px-4 md:px-6 py-8 md:py-12">
              {/* Main Content - 3 Column Layout */}
              <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-6">

                {/* Left Column - Core Values */}
                <div className="lg:col-span-4 order-2 lg:order-1">
                  <div className="bg-white rounded-2xl shadow-lg shadow-gray-200/50 p-6 md:p-8 border border-gray-100 hover:shadow-xl transition-shadow duration-300 h-full">
                    <div className="flex items-center gap-3 mb-6">
                      <div className="w-10 h-10 bg-gradient-to-r from-[#0F4D81] to-[#5eafd2] rounded-xl flex items-center justify-center">
                        <i className="fa-solid fa-star text-white text-lg"></i>
                      </div>
                      <h2 className="text-xl font-bold text-[#0F4D81]">วิสัยทัศน์</h2>
                    </div>
                    <div className="flex flex-col gap-4">
                      {coreValues.map((item, index) => (
                        <div
                          key={index}
                          className={`flex items-start gap-4 p-4 ${item.bgColor} rounded-xl border ${item.borderColor} border-opacity-30 hover:shadow-md transition-all duration-300 group cursor-default`}
                        >
                          <div className={`w-12 h-12 flex-shrink-0 ${item.bgColor} rounded-xl flex items-center justify-center border ${item.borderColor} border-opacity-50 group-hover:scale-110 transition-transform duration-300`}>
                            <span className={`text-2xl font-bold ${item.color}`}>{item.letter}</span>
                          </div>
                          <div>
                            <h4 className={`font-bold ${item.color} text-base`}>{item.title}</h4>
                            <p className="text-gray-600 text-sm leading-relaxed">{item.description}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Center Column - Vision & Logo */}
                <div className="lg:col-span-4 order-1 lg:order-2">
                  <div className="bg-white rounded-2xl shadow-lg shadow-gray-200/50 p-6 md:p-2 border border-gray-100 hover:shadow-xl transition-shadow duration-300 h-full flex flex-col items-center justify-center">
                    {/* Logo */}
                    <div className="mb-4">
                      <div className="w-32 h-32 md:w-40 md:h-40 rounded-full bg-gradient-to-br from-[#0F4D81]/10 to-[#9E76B3]/10 flex items-center justify-center p-4 border-4 border-[#5eafd2]/20">
                        <img
                          src="https://general.vet.cmu.ac.th/VMCMU.png"
                          alt="VMCMU Logo"
                          className="w-full h-full object-contain"
                        />
                      </div>
                    </div>

                    <h1 className="text-3xl md:text-4xl font-bold">
                      <span className="text-[#5eafd2]">VM</span>
                      <span className="text-[#9E76B3]">CMU</span>
                    </h1>
                    <p className="text-gray-500 text-sm md:text-base text-center mt-2 max-w-xs">
                      {coreValues.map(v => v.letter).join(' ')}
                    </p>
                    <p className="text-gray-400 text-xs md:text-sm mt-1">
                      Faculty of Veterinary Medicine
                    </p>

                    <div className="w-full h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent my-6"></div>

                    {/* Vision */}
                    <div className="text-center w-full">
                      <div className="flex items-center justify-center gap-2 mb-3">
                        <div className="w-8 h-8 bg-gradient-to-r from-[#9E76B3] to-[#5eafd2] rounded-lg flex items-center justify-center">
                          <i className="fa-regular fa-eye text-white text-sm"></i>
                        </div>
                        <h3 className="text-lg font-bold text-[#0F4D81]">วิสัยทัศน์ / Vision</h3>
                      </div>
                      <div className="bg-gradient-to-r from-[#0F4D81]/5 via-[#9E76B3]/5 to-[#5eafd2]/5 rounded-xl p-4 border border-[#5eafd2]/20">
                        <p className="text-gray-700 font-medium text-base md:text-lg">
                          {visionData.subtitle}
                        </p>
                        <p className="text-gray-400 text-sm italic mt-2">
                          {visionData.english}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right Column - Mission */}
                <div className="lg:col-span-4 order-3">
                  <div className="bg-white rounded-2xl shadow-lg shadow-gray-200/50 p-6 md:p-8 border border-gray-100 hover:shadow-xl transition-shadow duration-300 h-full">
                    <div className="flex items-center gap-3 mb-6">
                      <div className="w-10 h-10 bg-gradient-to-r from-[#9E76B3] to-[#5eafd2] rounded-xl flex items-center justify-center">
                        <i className="fa-solid fa-bullseye text-white text-lg"></i>
                      </div>
                      <h2 className="text-xl font-bold text-[#0F4D81]">พันธกิจ</h2>
                    </div>
                    <div className="flex flex-col gap-4">
                      {missions.map((mission, index) => (
                        <div
                          key={index}
                          className="flex items-start gap-4 p-4 bg-gray-50/50 rounded-xl border border-gray-100 hover:border-[#5eafd2]/30 hover:bg-[#5eafd2]/5 transition-all duration-300 group"
                        >
                          <div className="w-8 h-8 flex-shrink-0 bg-gradient-to-br from-[#0F4D81] to-[#5eafd2] rounded-lg flex items-center justify-center text-white text-sm font-bold group-hover:scale-110 transition-transform duration-300">
                            {index + 1}
                          </div>
                          <div>
                            <p className="text-gray-700 text-sm font-medium leading-relaxed">
                              {mission.th}
                            </p>
                            <p className="text-gray-400 text-xs italic mt-1 leading-relaxed">
                              {mission.en}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

              </div>

              {/* Bottom Decorative Banner */}
              <div className="mt-12 bg-gradient-to-r from-[#0F4D81]/5 via-[#9E76B3]/5 to-[#5eafd2]/5 rounded-2xl p-6 md:p-8 border border-[#5eafd2]/20 text-center">
                <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-[#0F4D81]/10 rounded-full flex items-center justify-center">
                      <i className="fa-regular fa-building text-[#0F4D81]"></i>
                    </div>
                    <div>
                      <p className="text-gray-700 text-sm font-medium">องค์กรแห่งความเป็นเลิศ</p>
                      <p className="text-gray-400 text-xs">Excellence Organization</p>
                    </div>
                  </div>
                  <div className="w-px h-8 bg-gray-300 hidden md:block"></div>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-[#9E76B3]/10 rounded-full flex items-center justify-center">
                      <i className="fa-regular fa-handshake text-[#9E76B3]"></i>
                    </div>
                    <div>
                      <p className="text-gray-700 text-sm font-medium">เครือข่ายวิชาชีพที่เข้มแข็ง</p>
                      <p className="text-gray-400 text-xs">Strong Professional Networks</p>
                    </div>
                  </div>
                  <div className="w-px h-8 bg-gray-300 hidden md:block"></div>
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-[#5eafd2]/10 rounded-full flex items-center justify-center">
                      <i className="fa-regular fa-heart text-[#5eafd2]"></i>
                    </div>
                    <div>
                      <p className="text-gray-700 text-sm font-medium">คุณภาพและธรรมาภิบาล</p>
                      <p className="text-gray-400 text-xs">Quality & Good Governance</p>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <Footer />
          </div>
        </div>
      )}
    </>
  );
}